import { render } from "./BrinkSlider.vue?vue&type=template&id=271871ee"
import script from "./BrinkSlider.vue?vue&type=script&lang=js"
export * from "./BrinkSlider.vue?vue&type=script&lang=js"

import "./BrinkSlider.vue?vue&type=style&index=0&id=271871ee&lang=css"
script.render = render

export default script